import React from 'react';
import AddIcon from '@material-ui/icons/AddCircleRounded';
import EyeIcon from '@material-ui/icons/VisibilityRounded';

import { OptionStyled } from './styledComponents';

export const Option = ({
  iconSrc,
  text,
  onPlusClick,
  onEyeClick,
  onClick,
  selected,
}) => (
  <OptionStyled onClick={onClick} selected={selected}>
    <img src={iconSrc} alt="Section Icon" />
    <span>{text}</span>
    {onPlusClick && (
      <AddIcon
        onClick={(e) => {
          e.stopPropagation();
          onPlusClick(e);
        }}
      />
    )}
    {onEyeClick && (
      <EyeIcon
        onClick={(e) => {
          e.stopPropagation();
          onEyeClick(e);
        }}
      />
    )}
  </OptionStyled>
);
